import React from 'react';

const Separator = () => {
  return <div className="mx-4 border-t border-white-400 lg:mx-7" />;
};

export default Separator;
